var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.482,
    height: 23.631,
    viewBox: "0 0 100.482 23.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56229",
    "data-name": "Group 56229",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41297_-_Outline",
    "data-name": "Path 41297 - Outline",
    d: "M67.45,12.376a2.765,2.765,0,0,1-2.788-2.788,2.788,2.788,0,1,1,5.576,0,2.765,2.765,0,0,1-2.788,2.788Zm-23.362,0A2.765,2.765,0,0,1,41.3,9.588,2.765,2.765,0,0,1,44.088,6.8a2.418,2.418,0,0,1,1.085.271,2,2,0,0,1,.819.641l.044.065-.566.566L45.4,8.259a1.516,1.516,0,0,0-1.315-.572,1.633,1.633,0,0,0-1.315.572l-.015.015a1.694,1.694,0,0,0-.572,1.4,1.694,1.694,0,0,0,.572,1.4,2.155,2.155,0,0,0,1.33.587,1.81,1.81,0,0,0,1.409-.58,1.331,1.331,0,0,0,.4-.878H43.992V9.319H46.7v.443a2.452,2.452,0,0,1-.636,1.8A2.635,2.635,0,0,1,44.088,12.376Zm31.1-.087h-.844L71.8,8.269v4.02H71v-5.4h.931l2.369,3.84V6.887h.887Zm-14.069,0h-.8v-4.6H58.843v-.8H62.6v.8H61.119Zm-2.866,0h-.887v-5.4h.887Zm-4.69,0h-.887v-4.6H51.2v-.8H55.04v.8H53.564Zm-2.866,0H47.466v-5.4H50.7v.8H48.353V9.145h2.171v.8H48.353V11.4H50.7ZM67.45,7.6a1.633,1.633,0,0,0-1.315.572l-.007.008a2,2,0,0,0-.58,1.409,1.694,1.694,0,0,0,.572,1.4l.008.007a1.956,1.956,0,0,0,1.322.58A1.633,1.633,0,0,0,68.765,11L68.772,11a2,2,0,0,0,.58-1.409,1.694,1.694,0,0,0-.572-1.4l-.008-.007A1.956,1.956,0,0,0,67.45,7.6Z",
    transform: "translate(-14.126 -6.8)",
    fill: "#050317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41298",
    "data-name": "Path 41298",
    d: "M64.549,21.182a3.654,3.654,0,0,0-3.734,3.734,3.707,3.707,0,0,0,3.734,3.734,3.654,3.654,0,0,0,3.734-3.734A3.6,3.6,0,0,0,64.549,21.182Zm0,5.906a2.265,2.265,0,0,1,0-4.516,2.1,2.1,0,0,1,2.084,2.258A2.156,2.156,0,0,1,64.549,27.087Zm-8.077-5.906a3.654,3.654,0,0,0-3.734,3.734,3.707,3.707,0,0,0,3.734,3.734,3.654,3.654,0,0,0,3.734-3.734A3.6,3.6,0,0,0,56.472,21.182Zm0,5.906a2.265,2.265,0,0,1,0-4.516,2.1,2.1,0,0,1,2.084,2.258A2.156,2.156,0,0,1,56.472,27.087Zm-9.64-4.777v1.563h3.734a3.284,3.284,0,0,1-.868,2A3.844,3.844,0,0,1,46.832,27a4.043,4.043,0,0,1-4.082-4.169,4.1,4.1,0,0,1,4.082-4.169A4.306,4.306,0,0,1,49.7,19.792l1.129-1.129A5.565,5.565,0,0,0,46.919,17.1,5.858,5.858,0,0,0,41.1,22.832a5.858,5.858,0,0,0,5.819,5.732,5,5,0,0,0,3.995-1.65,5.228,5.228,0,0,0,1.39-3.648,3.256,3.256,0,0,0-.087-.955H46.832ZM86.26,23.527a3.374,3.374,0,0,0-3.126-2.345,3.5,3.5,0,0,0-3.474,3.734,3.634,3.634,0,0,0,3.648,3.734A3.563,3.563,0,0,0,86.347,27l-1.216-.868a2.117,2.117,0,0,1-1.824,1.042,1.884,1.884,0,0,1-1.824-1.129l4.95-2.084-.174-.434Zm-5.037,1.216a2.11,2.11,0,0,1,1.911-2.171,1.536,1.536,0,0,1,1.39.782ZM77.141,28.3h1.65V17.447h-1.65Zm-2.605-6.34a2.859,2.859,0,0,0-2-.868,3.732,3.732,0,0,0-3.561,3.734,3.6,3.6,0,0,0,3.561,3.648,2.494,2.494,0,0,0,1.911-.868h.087v.521A1.974,1.974,0,0,1,70.715,29l-1.39.608a3.583,3.583,0,0,0,3.3,2.171c1.911,0,3.474-1.129,3.474-3.821v-6.6H74.536v.608Zm-1.911,5.124a2.265,2.265,0,0,1,0-4.516,2.089,2.089,0,0,1,2,2.258A2.089,2.089,0,0,1,72.625,27.087Zm21.191-9.64H89.908V28.3h1.65V24.221h2.258a3.391,3.391,0,1,0,0-6.774Zm.087,5.211H91.558V18.924H93.9a1.908,1.908,0,0,1,1.911,1.824A1.987,1.987,0,0,1,93.9,22.658Zm9.987-1.563a2.919,2.919,0,0,0-2.866,1.65l1.476.608a1.534,1.534,0,0,1,1.476-.782,1.632,1.632,0,0,1,1.737,1.39v.087a3.445,3.445,0,0,0-1.65-.434c-1.563,0-3.126.868-3.126,2.432a2.544,2.544,0,0,0,2.692,2.432,2.444,2.444,0,0,0,2.084-1.042h.087V28.3h1.563V24.135a3.287,3.287,0,0,0-3.474-3.04Zm-.174,5.992c-.521,0-1.3-.261-1.3-.955,0-.868.955-1.129,1.737-1.129a3.359,3.359,0,0,1,1.476.347A2.023,2.023,0,0,1,103.716,27.087Zm9.119-5.732-1.824,4.69h-.087l-1.911-4.69h-1.737l2.866,6.6-1.65,3.648h1.65l4.429-10.248h-1.737ZM98.245,28.3H99.9V17.447h-1.65Z",
    transform: "translate(-14.091 -8.146)",
    fill: "#050317"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55539",
    "data-name": "Group 55539",
    transform: "translate(0 0.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41299",
    "data-name": "Path 41299",
    d: "M10.347,7.5A1.7,1.7,0,0,0,10,8.716V27.909a1.718,1.718,0,0,0,.434,1.216l.087.087L21.29,18.443v-.174Z",
    transform: "translate(-10 -7.194)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41300",
    "data-name": "Path 41300",
    d: "M26.461,23.182,22.9,19.621v-.261L26.461,15.8l.087.087L30.8,18.319a1.325,1.325,0,0,1,0,2.519Z",
    transform: "translate(-11.697 -8.285)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41301",
    "data-name": "Path 41301",
    d: "M24.9,23.648,21.256,20,10.4,30.856c.434.434,1.042.434,1.824.087l12.68-7.3",
    transform: "translate(-10.053 -8.838)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41302",
    "data-name": "Path 41302",
    d: "M24.9,14.665,12.224,7.457a1.408,1.408,0,0,0-1.824.087L21.256,18.313Z",
    transform: "translate(-10.053 -7.15)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41303",
    "data-name": "Path 41303",
    d: "M24.817,24.1,12.224,31.221a1.42,1.42,0,0,1-1.737,0l-.087.087.087.087a1.42,1.42,0,0,0,1.737,0Z",
    transform: "translate(-10.053 -9.377)",
    fill: "#050317",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41304",
    "data-name": "Path 41304",
    d: "M10.347,30.682A1.7,1.7,0,0,1,10,29.466v.087a1.718,1.718,0,0,0,.434,1.216v-.087h-.087Zm18.759-9.553-4.342,2.432.087.087,4.255-2.432A1.444,1.444,0,0,0,29.975,20C29.975,20.434,29.627,20.782,29.106,21.129Z",
    transform: "translate(-10 -8.838)",
    fill: "#050317",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41305",
    "data-name": "Path 41305",
    d: "M12.171,7.54l16.935,9.64c.521.347.868.695.868,1.129a1.444,1.444,0,0,0-.868-1.216L12.171,7.454C10.955,6.759,10,7.28,10,8.669v.087C10,7.454,10.955,6.846,12.171,7.54Z",
    transform: "translate(-10 -7.147)",
    fill: "#fff",
    opacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.ba0ff1f6141d5fbacc31c219d70ddb62.svg";
export { ForwardRef as ReactComponent };